module.exports = __webpack_public_path__ + "assets/img/239f935985b8e50fa69ae6da017d5931.png";